var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4386,
    cy: 25.4386,
    r: 25.4386,
    fill: "#ED1C00",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30.9261C15 30.3187 15.1548 29.7214 15.4498 29.1904L21.6357 18.0558C22.184 17.0688 23.1381 16.3724 24.2452 16.151V16.151C24.7435 16.0513 25.2565 16.0513 25.7548 16.151V16.151C26.8619 16.3724 27.816 17.0688 28.3643 18.0558L34.5502 29.1904C34.8452 29.7214 35 30.3187 35 30.9261V30.9261C35 32.8999 33.3999 34.5 31.4261 34.5H18.5739C16.6001 34.5 15 32.8999 15 30.9261V30.9261Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22L25 26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29L25 29.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispute);
export default __webpack_public_path__ + "static/media/dispute.40c85e7329687c1d83b5673e92e56d10.svg";
export { ForwardRef as ReactComponent };